import { withFebruaryPromoWrapper } from './FebruaryPromo';

export const FebruaryPromoBanner = withFebruaryPromoWrapper(() => null);
